import { render, staticRenderFns } from "./TitleWithMessage.vue?vue&type=template&id=7b05a974"
import script from "./TitleWithMessage.vue?vue&type=script&lang=js"
export * from "./TitleWithMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports